import React from 'react';

import wrapPage from 'components/atoms/wrapPage/wrapPage';
import { adminPageContainerMaxWidth, adminPageContainerSx } from './adminPageLayoutConfig';

export const wrapAdminPage = (WrappedComponent: React.FunctionComponent<React.PropsWithChildren<unknown>>) =>
  wrapPage(WrappedComponent, adminPageContainerSx, adminPageContainerMaxWidth);
